import { ChevronDown } from "lucide-react";
import type { CSSProperties, ReactNode } from "react";

export type TaskFieldSectionProps = {
  icon: ReactNode;
  title: string;
  summary?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  colors: { bar: string; soft: string; ink: string };
  children: ReactNode;
};

export default function TaskFieldSection({
  icon,
  title,
  summary,
  open,
  onOpenChange,
  colors,
  children,
}: TaskFieldSectionProps) {
  return (
    <section
      className="task-field-section"
      style={{
        "--task-field-bar": colors.bar,
        "--task-field-soft": colors.soft,
        "--task-field-ink": colors.ink,
      } as CSSProperties}
    >
      <button
        type="button"
        className="field-header"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        <span className="field-icon" aria-hidden>{icon}</span>
        <span className="field-title">{title}</span>
        {summary ? <span className="field-summary">{summary}</span> : null}
        <ChevronDown className="field-chevron" aria-hidden />
      </button>
      {open ? <div className="field-body">{children}</div> : null}
    </section>
  );
}
